import "./AcceptInvitation.css";

import bgImage from "../../../assets/images/Mountain.jpg";
import { AuthenticationTemplate } from "../../../templates";
import { getLogonRoute } from "../../../utils/routes";
import { Button, Column, ErrorBox, InformationBox, Row } from "../../../widget";
import { AcceptInvitationForm } from "./form";
import { useAcceptInvitation } from "./useAcceptInvitation";

export const AcceptInvitation = (): JSX.Element => {
  const {
    urlToken,
    developerName,
    accountCreated,
    email,
    firstName,
    hasSharedInvitationQueryParams,
    lastName,
    navigation,
    sharedInvitationContext,
    sharedInvitationQueryParamErrors,
    setAccountCreated,
  } = useAcceptInvitation();

  if (accountCreated) {
    return (
      <AuthenticationTemplate imageSrc={bgImage}>
        <Row spacingV="ll">
          <Column span={12}>
            <h1>Welcome</h1>
          </Column>
        </Row>
        <Row spacingV="ll">
          <Column span={12}>
            <InformationBox variant="success" title="Account created">
              <p>Thank you for accepting your invitation.</p>
              <p>You can now log in with your new password to continue the setup process.</p>
            </InformationBox>
          </Column>
        </Row>
        <Row>
          <Column span={12}>
            <Button
              fullWidth
              text="Log in"
              onClick={() => {
                navigation(getLogonRoute());
              }}
            />
          </Column>
        </Row>
      </AuthenticationTemplate>
    );
  }

  if (!urlToken) {
    return (
      <AuthenticationTemplate imageSrc={bgImage}>
        <Row spacingV="ll">
          <Column span={12}>
            <h1>Welcome</h1>
          </Column>
        </Row>
        <Row className="AcceptInvitationTokenNotFound">
          <Column span={12}>
            <ErrorBox text="Copy the link from the invitation and paste it directly into the browser" />
          </Column>
        </Row>
      </AuthenticationTemplate>
    );
  }

  const isSharedInvitation = hasSharedInvitationQueryParams && !!sharedInvitationContext;

  return (
    <AuthenticationTemplate imageSrc={bgImage}>
      <Row spacingV={isSharedInvitation ? "ll" : "m"}>
        <Column span={12}>
          {isSharedInvitation ? (
            <div className="AcceptInvitationHeader AcceptInvitationHeaderShared">
              <h1>Welcome</h1>
              <div className="AcceptInvitationIntro body1">
                <p>
                  You have been invited by {sharedInvitationContext.senderFirstName}{" "}
                  {sharedInvitationContext.senderLastName} at {sharedInvitationContext.sourceOrganisationDisplayName} to
                  join Kana.Earth and access their project: {sharedInvitationContext.projectName}.
                </p>
                <p>
                  Please enter a password to create a new account. If you already have an account, please enter your
                  existing password.
                </p>
              </div>
            </div>
          ) : (
            <h1>Welcome</h1>
          )}
        </Column>
      </Row>

      {hasSharedInvitationQueryParams && sharedInvitationQueryParamErrors.length > 0 ? (
        <Row spacingV="ll">
          <Column span={12}>
            <ErrorBox
              title="Invalid invitation link"
              text={[
                "This invitation link is missing required project details. Please request a new invitation.",
                ...sharedInvitationQueryParamErrors,
              ]}
            />
          </Column>
        </Row>
      ) : (
        <>
          {!isSharedInvitation && (
            <Row spacingV="ml">
              <Column className="body2" span={12}>
                <p>You have been invited to join {developerName} on Kana.</p>
                <p>
                  Please enter a password to create a new account. If you already have an account, please enter your
                  existing password.
                </p>
              </Column>
            </Row>
          )}

          <AcceptInvitationForm
            urlToken={urlToken}
            email={email}
            firstName={firstName}
            isSharedInvitation={isSharedInvitation}
            lastName={lastName}
            onSuccess={setAccountCreated}
          />
        </>
      )}
    </AuthenticationTemplate>
  );
};
